import { put, call, select } from "redux-saga/effects";
import { path } from "ramda";
import ModalUtil from "../util/modal";
import UserActions from "../reducers/UserReducer";

const getMe = function* (api) {
	try {
		const token = yield select(state => state.authen.token);
		const res = yield call(api.getMe, token);
		const data = path(["data", "data"], res);
		if (res.ok && data) {
			yield put(UserActions.getUserSuccess(data));
		} else {
			ModalUtil.showError(res);
			yield put(UserActions.getUserFailure());
		}
	} catch (e) {
		ModalUtil.showDefaultError();
		yield put(UserActions.getUserFailure());
	}
};

export { getMe };


// WEBPACK FOOTER //
// ./src/sagas/UserSaga.js